/* XYZ Quick-Add popup (v2.1 — Casetify-style model gate; add-in-place; colour-split aware).
   Colour-split products (iPhone 17 Pro Max) have ONE Color variant each — their colour row is
   built from Rubik's colour group (parsed out of the PDP html we already fetch), and a swatch
   switches PRODUCT rather than variant. Colour carries across model switches both ways.
   Pick a MODEL (highlights, popup switches to that model's image/colors/price) + a COLOR,
   then "Add to Cart" adds that exact model+color variant and opens the cart drawer — no PDP trip.
   Sold-out model+color disables the button ("Sold Out"). "See Details" still routes to the PDP.
   Models list from the PDP device-selector series_json; per-model data from /products/{handle}.js.
   Cart drawer note (verified live): dispatching 'theme:cartchanged' REFRESHES the drawer/header
   count but does NOT open it — clicking a.cart-link is the theme's actual opener. Both are needed. */
(function () {
  'use strict';
  if (window.__xqaBound) return; window.__xqaBound = true;
  var pcache = {}, scache = {};
  var S = { models:[], rubik:[], sub:'', handle:null, product:null, colorName:null, variantId:null };
  var CHK = '<svg viewBox="0 0 16 16" width="15" height="15" fill="none"><path d="M3 8.5L6.5 12L13 4.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ORDER = ['Apple','Samsung','Google','Other'];

  function el(id){ return document.getElementById(id); }
  function ov(){ return el('xqa-overlay'); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function handleOf(u){ return String(u||'').split('?')[0].replace(/\/$/,'').split('/').pop(); }
  function money(c){ return '$'+(c/100).toFixed(2); }
  function bigImg(src){ return (src||'').replace(/(\.[a-z]+)(\?|$)/i,'_400x$1$2'); }
  function colorIdx(p){ var o=p.options||[]; for(var i=0;i<o.length;i++){ var n=(o[i].name||o[i]||'').toString().toLowerCase(); if(n==='color'||n==='colour') return i; } return 0; }
  function colorValues(p){ var idx=colorIdx(p), seen=[], out=[]; p.variants.forEach(function(v){ var c=v.options[idx]; if(c&&seen.indexOf(c)===-1){ seen.push(c); out.push(c); } }); return out; }
  function variantForColor(p,color){ var idx=colorIdx(p); for(var i=0;i<p.variants.length;i++){ if((p.variants[i].options[idx]||'')===color) return p.variants[i]; } return p.variants[0]; }
  function swatchColor(name){ var m={black:'#111',white:'#fff',pink:'#f7b8cd','hot pink':'#ff5fa2',blue:'#4a72c4',purple:'#8a6fc0',gold:'#d4af37','rose gold':'#e6b9a6',silver:'#cfd2d6',clear:'#e9edf2',brown:'#7a5230',green:'#3f9c6a',orange:'#e8853b',amber:'#ffbf47'}; return m[(name||'').toLowerCase()]||'#ccc'; }

  function fetchProduct(handle){ if(pcache[handle]) return Promise.resolve(pcache[handle]);
    return fetch('/products/'+handle+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.ok?r.json():null;}).then(function(p){ if(p) pcache[handle]=p; return p; }).catch(function(){ return null; }); }
  /* One HTML fetch yields BOTH: the device-selector's model list (data-xds-data) and — for
     colour-split products — Rubik's colour siblings (data-rubik-swatch-product-id payload,
     groups[].swatches). A split child has a single Color variant, so its colours can only come
     from the Rubik group; without this the popup would show just one swatch. */
  function fetchMeta(handle){ if(scache[handle]) return Promise.resolve(scache[handle]);
    return fetch('/products/'+handle,{headers:{'Accept':'text/html'}}).then(function(r){return r.ok?r.text():'';}).then(function(html){
      /* NOTE: anchor on '<script ... attr ...>' — matching the bare attribute name also hits the
         device-selector's Rubik-hiding CSS ([data-rubik-swatch-product-id]{display:none}), which
         appears EARLIER in the html, so .match() grabbed the stylesheet and JSON.parse died. */
      var models=[]; var m=html.match(/<script[^>]*\bdata-xds-data\b[^>]*>([\s\S]*?)<\/script>/);
      if(m){ try{ models=JSON.parse(m[1].trim()); }catch(e){} }
      var colors=[];
      /* Prefer OUR colour payload (xyz-color-selector) — no Rubik dependency. */
      var xm=html.match(/<script[^>]*\bdata-xcs-data\b[^>]*>([\s\S]*?)<\/script>/);
      if(xm){ try{
        colors=(JSON.parse(xm[1].trim())||[]).map(function(c){
          return { value:c.color, url:c.url, available:(c.available!==false) };
        }).filter(function(c){ return c.value&&c.url; });
      }catch(e){} }
      /* Fallback: Rubik's own payload (themes where xyz-color-selector isn't deployed). */
      if(!colors.length){
        var rm=html.match(/<script[^>]*\bdata-rubik-swatch-product-id\b[^>]*>([\s\S]*?)<\/script>/);
        if(rm){ try{
          var j=JSON.parse(rm[1].trim());
          var g=(j.groups||[]).filter(function(x){ var n=String(x.optionName||'').toLowerCase(); return n==='color'||n==='colour'; })[0];
          if(g&&g.swatches){ colors=g.swatches.map(function(s){
            return { value:(s.optionValue||s.option_value||s.value), url:(s.productUrl||s.product_url||s.url), available:(s.productAvailable!==false) };
          }).filter(function(c){ return c.value&&c.url; }); }
        }catch(e){} }
      }
      var meta={models:models,colors:colors}; scache[handle]=meta; return meta;
    }).catch(function(){ var meta={models:[],colors:[]}; scache[handle]=meta; return meta; }); }
  /* ---- SINGLE-REQUEST LOADER ------------------------------------------------------------
     Was: /products/{h}.js (9KB) + /products/{h} (448KB full PDP page, 98% discarded) = ~755ms.
     Now: /products/{h}?view=xqa -> templates/product.xqa.liquid ({% layout none %}) returns just
     the JSON the popup needs (~9KB) in ONE request = ~336ms (network-latency bound).
     Falls back to the legacy pair if the view is missing (e.g. a theme without the template). */
  var xcache = {};
  /* Draft-theme previews must keep preview_theme_id on these fetches, or they resolve against
     the LIVE theme (which has no xqa template) and silently fall back to the slow path. No-op live. */
  var xqaPreview = (function(){ var m=/[?&]preview_theme_id=(\d+)/.exec(location.search); return m?'&preview_theme_id='+m[1]:''; })();
  function fetchXQA(handle){
    if(xcache[handle]) return Promise.resolve(xcache[handle]);
    /* NO Accept:application/json header — that makes Shopify serve its BUILT-IN product JSON
       API and bypass the theme template entirely, so ?view=xqa would be silently ignored. */
    return fetch('/products/'+handle+'?view=xqa'+xqaPreview)
      .then(function(r){ return r.ok ? r.text() : null; })
      .then(function(txt){
        if(!txt) return legacyLoad(handle);
        var d=null; try{ d=JSON.parse(txt.trim()); }catch(e){ return legacyLoad(handle); }
        if(!d || !d.variants) return legacyLoad(handle);
        var out={ product:d, models:(d.series||[]),
          colors:(d.colors||[]).map(function(c){ return { value:c.color, url:c.url, available:(c.available!==false) }; })
                                .filter(function(c){ return c.value&&c.url; }) };
        xcache[handle]=out; return out;
      })
      .catch(function(){ return legacyLoad(handle); });
  }
  function legacyLoad(handle){
    return Promise.all([fetchProduct(handle), fetchMeta(handle)]).then(function(res){
      if(!res[0]) return null;
      var meta=res[1]||{models:[],colors:[]};
      var out={ product:res[0], models:meta.models||[], colors:meta.colors||[] };
      xcache[handle]=out; return out;
    });
  }

  function switchColor(h){
    if(!h||h===S.handle) return;
    fetchXQA(h).then(function(d){
      if(!d||!d.product) return;
      S.rubik=d.colors||[];
      if(d.models&&d.models.length) S.models=d.models;
      selectProduct(d.product, null);
    });
  }

  /* series_json lists only the CANONICAL colour for a split model, so a non-canonical colour
     (e.g. …-silver) would otherwise fail the "is this my model?" test — treat colour siblings
     as the same model for labelling/highlighting. */
  function sameModel(url){
    var h=handleOf(url); if(h===S.handle) return true;
    if(S.rubik && S.rubik.length>1){
      var hs=S.rubik.map(function(c){ return handleOf(c.url); });
      return hs.indexOf(h)!==-1 && hs.indexOf(S.handle)!==-1;
    }
    return false;
  }
  function currentVariant(){ var p=S.product; if(!p) return null;
    return p.variants.filter(function(x){return x.id===S.variantId;})[0]||p.variants[0]; }
  function syncAtc(){
    var b=el('xqa-atc'); if(!b) return;
    var v=currentVariant(), avail=!!(v&&v.available);
    var pre=!!(S.product&&S.product.preorder);   /* pre-order: tag-driven flag from product.xqa.liquid; absent on legacy path = false */
    b.disabled=!avail; b.textContent=avail?(pre?'Pre-order':'Add to Cart'):'Sold Out';
    var pn=el('xqa-prenote'); if(pn){ if(pre&&avail&&S.product.preorder_note){ pn.textContent=S.product.preorder_note; pn.hidden=false; } else { pn.hidden=true; } }
  }
  function showErr(msg){
    var e=el('xqa-err'); if(!e) return;
    e.textContent=msg; e.hidden=false;
    clearTimeout(e._t); e._t=setTimeout(function(){ e.hidden=true; }, 5000);
  }
  function openCartDrawer(){
    // refresh drawer contents + header count, THEN open via the theme's own control
    document.dispatchEvent(new CustomEvent('theme:cartchanged',{bubbles:true,cancelable:true}));
    var link=document.querySelector('a.cart-link');
    if(link){ link.click(); } else { window.location.href='/cart'; } // fallback if cart_type=page
  }
  function addToCart(){
    var b=el('xqa-atc'); if(!b||b.disabled) return;
    var v=currentVariant();
    if(!v||!v.available){ syncAtc(); return; }
    var id=S.variantId;
    b.disabled=true;
    /* State machine: idle -> (silent <=180ms) -> spinner -> success tick (900ms) -> drawer.
       The spinner only appears if the request outlives 180ms, so the common fast path
       jumps straight to the tick with no flicker. */
    var spin=setTimeout(function(){ b.innerHTML='<span class="xqa-spin" aria-hidden="true"></span>Adding'; },180);
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:id,quantity:1}]})})
      .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, body:j}; }); })
      .then(function(res){
        clearTimeout(spin);
        if(!res.ok) throw new Error((res.body&&(res.body.description||res.body.message))||'Could not add to cart');
        b.classList.add('is-added');
        b.innerHTML='<span class="xqa-tick" aria-hidden="true">✓</span>Added';
        setTimeout(function(){
          close();
          openCartDrawer();
          b.classList.remove('is-added');
          syncAtc();
        },900);
      })
      .catch(function(err){ clearTimeout(spin); b.classList.remove('is-added'); syncAtc(); showErr(String(err&&err.message||err)); });
  }

  function setColor(color){
    var p=S.product, v=variantForColor(p,color);
    S.colorName=v.options[colorIdx(p)]; S.variantId=v.id;
    el('xqa-img').src=bigImg((v.featured_image&&v.featured_image.src)||p.featured_image);
    el('xqa-price').textContent=money(v.price);
    el('xqa-colorname').textContent=S.colorName;
    document.querySelectorAll('.xqa-sw').forEach(function(x){ x.classList.toggle('is-on', x.getAttribute('data-xqa-color')===S.colorName); });
    syncAtc();
  }
  function selectProduct(p, keepColor){
    S.product=p; S.handle=p.handle;
    var colors=colorValues(p);
    var chosen=(keepColor && colors.indexOf(keepColor)!==-1)?keepColor:null;
    var v=chosen?variantForColor(p,chosen):(p.variants.filter(function(x){return x.available;})[0]||p.variants[0]);
    S.colorName=v.options[colorIdx(p)]; S.variantId=v.id;
    renderAll();
  }
  function renderAll(){
    var p=S.product, v=p.variants.filter(function(x){return x.id===S.variantId;})[0]||p.variants[0];
    el('xqa-img').src=bigImg((v.featured_image&&v.featured_image.src)||p.featured_image);
    el('xqa-title').textContent=p.title.replace(/\s*\|.*$/,'').trim()||p.title;
    var cm=(S.models.filter(function(m){return sameModel(m.url);})[0]||{}).model || (p.title.split('|')[1]||'').trim() || p.title;
    if(S.colorName){ cm=cm.replace(new RegExp('\\s*[-–]\\s*'+S.colorName.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')+'\\s*$','i'),''); }
    el('xqa-modelname').textContent=cm;
    el('xqa-sub').textContent=S.sub;
    el('xqa-details').href='/products/'+S.handle;
    el('xqa-price').textContent=money(v.price);
    el('xqa-colorname').textContent=S.colorName;
    if(S.rubik && S.rubik.length>1){
      /* colour-split: each colour is its OWN product — swatches switch product, not variant */
      el('xqa-colors').innerHTML=S.rubik.map(function(c){ var ch=handleOf(c.url); var on=(ch===S.handle);
        return '<button type="button" class="xqa-sw'+(on?' is-on':'')+(c.available?'':' is-oos')+'" data-xqa-chandle="'+esc(ch)+'" aria-label="'+esc(c.value)+'"><span style="background:'+swatchColor(c.value)+'"></span></button>'; }).join('');
    } else {
      el('xqa-colors').innerHTML=colorValues(p).map(function(c){ var cv=variantForColor(p,c); return '<button type="button" class="xqa-sw'+(c===S.colorName?' is-on':'')+(cv&&!cv.available?' is-oos':'')+'" data-xqa-color="'+esc(c)+'" aria-label="'+esc(c)+'"><span style="background:'+swatchColor(c)+'"></span></button>'; }).join('');
    }
    var groups={}; S.models.forEach(function(m){ (groups[m.brand]=groups[m.brand]||[]).push(m); });
    var curBrand=(S.models.filter(function(m){return sameModel(m.url);})[0]||{}).brand;
    var view=ov().getAttribute('data-xqa-view'); if(!view||!groups[view]) view=groups[curBrand]?curBrand:Object.keys(groups)[0];
    ov().setAttribute('data-xqa-view',view||'');
    el('xqa-brands').innerHTML=ORDER.filter(function(b){return groups[b];}).map(function(b){ return '<button type="button" class="xqa-tab'+(b===view?' is-on':'')+'" data-xqa-brand="'+esc(b)+'">'+esc(b)+'</button>'; }).join('');
    el('xqa-models').innerHTML=(groups[view]||[]).map(function(m){ var on=sameModel(m.url);
      return '<li><button type="button" class="xqa-model'+(on?' is-cur':'')+'" data-xqa-mh="'+esc(handleOf(m.url))+'"><span>'+esc(m.model)+'</span>'+'</button></li>'; }).join('');
    syncAtc();
  }

  function open(trigger){
    var handle=trigger.getAttribute('data-xqa-handle'); if(!handle) return;
    S.sub=trigger.getAttribute('data-xqa-sub')||''; ov().removeAttribute('data-xqa-view');
    fetchXQA(handle).then(function(d){ if(!d||!d.product) return; S.models=d.models||[]; S.rubik=d.colors||[]; selectProduct(d.product, null); show(); });
  }
  /* Scroll lock — same position:fixed body lock as the device-memory panel:
     plain overflow:hidden (a) doesn't stop real wheel scroll in Chrome here and (b) removes the
     scrollbar, so the centred layout stepped ~15px right on open. Freeze the body at its offset,
     reserve the scrollbar's width, restore the exact position on close. */
  var xqaLockY=0, xqaLocked=false;
  function show(){
    ov().hidden=false;
    xqaLockY=window.scrollY||0; xqaLocked=true;
    var sbw=window.innerWidth-document.documentElement.clientWidth;
    if(sbw>0){ document.body.style.paddingRight=sbw+'px'; }
    document.body.style.position='fixed';
    document.body.style.top=(-xqaLockY)+'px';
    document.body.style.left='0'; document.body.style.right='0'; document.body.style.width='100%';
  }
  function close(){
    ov().hidden=true;
    if(xqaLocked && document.body.style.position==='fixed'){
      xqaLocked=false;
      document.body.style.position=''; document.body.style.top='';
      document.body.style.left=''; document.body.style.right=''; document.body.style.width='';
      document.body.style.paddingRight='';
      window.scrollTo(0, xqaLockY||0);
    }
  }

  /* Touch devices never fire mouseover before a tap, so phones paid the full
     round trip on every first open. touchstart lands ~100-300ms before click —
     enough to have the 5KB payload in flight by the time the popup renders. */
  function prefetchFrom(e){
    var t=e.target.closest('.xqa-trigger');
    if(t){ var h=t.getAttribute('data-xqa-handle'); if(h) fetchXQA(h); return; }
    var mo=e.target.closest('.xqa-model[data-xqa-mh]'); if(mo) fetchXQA(mo.getAttribute('data-xqa-mh'));
    var cs2=e.target.closest('[data-xqa-chandle]'); if(cs2) fetchXQA(cs2.getAttribute('data-xqa-chandle'));
  }
  document.addEventListener('mouseover', prefetchFrom);
  document.addEventListener('touchstart', prefetchFrom, {passive:true});

  /* Warm the first few visible cards once the page is otherwise done.
     Deliberately conservative: this competes for the same bandwidth that made
     the popup feel slow in the first place (below-fold autoplay video was
     saturating the connection), so it waits for load, runs only in idle time,
     respects Data Saver / slow connections, and stops at a handful of cards. */
  function idlePrewarm(){
    var c=navigator.connection;
    if(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType||''))) return;
    var run=function(){
      var seen={}, n=0;
      var trigs=document.querySelectorAll('.xqa-trigger[data-xqa-handle]');
      for(var i=0;i<trigs.length && n<4;i++){
        var el=trigs[i], b=el.getBoundingClientRect();
        if(b.top>window.innerHeight || b.bottom<0) continue;   /* visible only */
        var h=el.getAttribute('data-xqa-handle');
        if(!h || seen[h]) continue;
        seen[h]=1; n++; fetchXQA(h);
      }
    };
    if(window.requestIdleCallback) requestIdleCallback(run,{timeout:3000});
    else setTimeout(run,1500);
  }
  if(document.readyState==='complete') idlePrewarm();
  else window.addEventListener('load', idlePrewarm);
  document.addEventListener('click', function(e){
    var trig=e.target.closest('.xqa-trigger'); if(trig){ e.preventDefault(); open(trig); return; }
    if(!ov()||ov().hidden) return;
    if(e.target.closest('.xqa-close')||e.target.id==='xqa-overlay'){ close(); return; }
    var cs=e.target.closest('[data-xqa-chandle]'); if(cs){ switchColor(cs.getAttribute('data-xqa-chandle')); return; }
    var sw=e.target.closest('[data-xqa-color]'); if(sw){ setColor(sw.getAttribute('data-xqa-color')); return; }
    var tab=e.target.closest('[data-xqa-brand]'); if(tab){ ov().setAttribute('data-xqa-view', tab.getAttribute('data-xqa-brand')); renderAll(); return; }
    var mo=e.target.closest('.xqa-model[data-xqa-mh]'); if(mo){ var mh=mo.getAttribute('data-xqa-mh'); if(mh===S.handle) return;
      if(S.rubik && S.rubik.length>1 && S.rubik.filter(function(c){return handleOf(c.url)===mh;})[0]) return; /* same model, other colour */
      var want=S.colorName;
      fetchXQA(mh).then(function(d){
        if(!d||!d.product) return;
        var meta={models:d.models||[], colors:d.colors||[]};
        /* target model is colour-split: hop straight to the sibling matching the chosen colour */
        if(meta.colors && meta.colors.length>1 && want){
          var hit=meta.colors.filter(function(c){ return c.value===want; })[0];
          if(hit){ var h2=handleOf(hit.url); if(h2 && h2!==mh){ switchColor(h2); return; } }
        }
        S.rubik=meta.colors||[];
        if(meta.models&&meta.models.length) S.models=meta.models;
        selectProduct(d.product, want);
      });
      return; }
    var go=e.target.closest('#xqa-atc'); if(go){ addToCart(); return; }
  });
  /* ---- colour-split card preview: hover a dot -> show that colour's image -------------------
     The theme's own swatch swap toggles pre-rendered [data-media-id] divs, which only works when
     every colour is a VARIANT of the same product. Split siblings are separate products, so their
     images aren't in this card's DOM at all — we swap the src from color_json's `image` instead.
     Hover-only by design: the dot never selects, and clicking the card still opens the card's own
     colour. Restores on mouseout. */
  function xcsCardImg(card){
    return card.querySelector('.product-block__image--active img') ||
           card.querySelector('.product-block__image--primary img') ||
           card.querySelector('.product-block__image img');
  }
  document.addEventListener('mouseover', function(e){
    var dot=e.target.closest('.product-block-options--preview .product-block-options__item[data-xcs-img]');
    if(!dot) return;
    var card=dot.closest('.product-block'); if(!card) return;
    var img=xcsCardImg(card); if(!img) return;
    if(img.getAttribute('data-xcs-orig')===null){
      img.setAttribute('data-xcs-orig', img.currentSrc||img.getAttribute('src')||'');
      img.setAttribute('data-xcs-orig-srcset', img.getAttribute('srcset')||'');
    }
    img.removeAttribute('srcset');          /* srcset would override a bare src */
    img.removeAttribute('sizes');
    img.src=dot.getAttribute('data-xcs-img');
  });
  document.addEventListener('mouseout', function(e){
    var dot=e.target.closest('.product-block-options--preview .product-block-options__item[data-xcs-img]');
    if(!dot) return;
    var card=dot.closest('.product-block'); if(!card) return;
    var img=xcsCardImg(card); if(!img) return;
    var orig=img.getAttribute('data-xcs-orig'); if(orig===null) return;
    var ss=img.getAttribute('data-xcs-orig-srcset');
    img.src=orig;
    if(ss) img.setAttribute('srcset', ss);
  });

  document.addEventListener('keydown', function(e){ if(e.key==='Escape'&&ov()&&!ov().hidden) close(); });
}());
